import {
  Autocomplete,
  Card,
  CardContent,
  CardHeader,
  DialogContentText,
  FormControl,
  InputLabel,
  TextField,
  useMediaQuery,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import NoDataFound from "../CustomComponents/NoDataFound";
import StlapFooter from "../CustomComponents/StlapFooter";
import { BranchAction } from "../Store/Branch";
import { ParaMeterReducerAction } from "../Store/ParameterMaintenance/ParaMeterReducer";
import MoreAction from "./MoreAction";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import Tooltip from "@mui/material/Tooltip";
import store from "../Store";
const ParameterMaintenance = () => {
  const escValue = useSelector((state) => state.paraMeter.EscapeValue);
  const editViewMode = useSelector((state) => state.paraMeter.EditViewMode);
  const columns = [
    {
      field: "paramName",
      headerName: "Parameter Name",
      headerAlign: "center",
      align: "center",
      flex: 200,
      align: "left",
    },
    {
      field: "module",
      headerName: "Module",
      headerAlign: "center",
      align: "center",
      flex: 200,
      align: "left",
    },
    {
      field: "paramDataType",
      headerName: "Parameter Data Type",
      headerAlign: "center",
      align: "center",
      flex: 185,
      align: "left",
    },
    {
      field: "paramValue",
      headerName: "Parameter Value",
      headerAlign: "center",
      align: "center",
      flex: 200,
      align: "right",
      renderCell: (params) => {
        if (params.row.paramDataType === "Int") {
          return parseInt(params.value).toLocaleString("en-IN");
        } else if (params.row.paramDataType === "Date") {
          return dayjs(params.value).format("DD/MM/YYYY");
        }
        //else if (params.row.paramDataType === "Float") {
        //   return Number(params.value.replaceAll(",", "")).toFixed(2);
        // }
        else {
          return params.value;
        }
      },
    },
    {
      field: "paramEffStartDate",
      headerName: "Effective Start Date",
      headerAlign: "center",
      align: "center",
      flex: 207,
      align: "right",
      renderCell: (params) => {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "paramEffEndDate",
      headerName: "Effective End Date",
      headerAlign: "center",
      align: "center",
      flex: 207,
      align: "right",
      renderCell: (params) => {
        return dayjs(params.value).format("DD/MM/YYYY");
      },
    },
    {
      field: "action",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 123,
      hideable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <MoreAction
            params={params.row}
            viewClickHandler={viewClickHandler}
            modifyClickHandler={modifyClickHandler}
            viewRef={viewRef}
            modifyRef={modifyRef}
          />
        );
      },
    },
  ];
  const [globalRows, setGlobalRows] = useState([]);
  const [branchArray, setBranchArray] = useState([]);
  const [branchValues, setBranchValues] = useState();
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  //State which manitain the date data type selected or not
  const [dateValue, setDateValue] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  //State for maintaining search conditions
  const [pModule, setModule] = useState();
  const [moduleArray, setModuleArray] = useState([]);
  const [discardMode, setDiscardMode] = useState(false);
  const [discardDialog, setDiscardDialog] = useState("");
  const [discardDialogTitle, setDiscardDialogTitle] = useState("");
  const [columnsData, setColumns] = useState(columns);
  const [effectiveStartDateEnabled, setEffectiveStartDateEnabled] =
    useState(false);
  const [effectiveEndDateEnabled, setEffectiveEndDateEnabled] = useState(false);
  //Getting UserName
  const [userName, setUserName] = useState("");
  //ROw count
  const rowsPerPage = 10;

  const [totalRowsCount, setTotalRowsCount] = useState(0);
  /** Getting Current date */
  const branchDetails = useSelector((state) => state.branch.header);
  /**Disabled State */
  const [disabled, setdisabled] = useState(false);
  const [mode, setMode] = useState("0");
  /**Parameter Values */
  const [paramaId, setParamId] = useState("");
  const [paraMeterName, setParamMeterName] = useState("");
  const [paramDataType, setparamDataType] = useState("");
  const [startDate, setstartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [modules, setModules] = useState("");
  const [ParamValue, setParamValue] = useState("");
  // view cancel Button Handler
  const [showOkCancel, setShowOkCancel] = useState(false);
  /**Touch State Handlers */
  const [paramNameTouched, setParamNameTouched] = useState(false);
  const [paramTypeTouched, setParamTypeTouched] = useState(false);
  const [startDateTouched, setStartDateTouched] = useState(false);
  const [endDateTouched, setEndDateTouched] = useState(false);
  const [paramValueTouched, setParamValueTouched] = useState(false);
  /**Ok Button Handler */
  const [OkButtonHandler, setOkButtonHandler] = useState(false);
  /**Discard Changes */
  const [cancelOpen, cancelSetOpen] = React.useState(false);
  //Error message for ParamValue
  const [paramErrorMessage, setParamErrorMessage] = useState("");
  /**Valid Handler */
  const paramNameIsValid =
    paraMeterName.trim() !== "" && paraMeterName.trim().length < 50;
  const paramTypeIsValid = paramDataType !== "";
  let paramValueIsValid;
  if (paramDataType === "Varchar") {
    paramValueIsValid = ParamValue.trim() !== "";
  } else if (paramDataType === "Date") {
    paramValueIsValid = ParamValue !== "";
  } else {
    paramValueIsValid =
      ParamValue.length !== 0 &&
      Number(ParamValue.replaceAll(",", "")) <= 9999999999 &&
      ParamValue !== "0";
  }
  const effectiveStartDateIsValid =
    new Date(startDate).toDateString() !== "Invalid Date" &&
    startDate !== null &&
    new Date(startDate).toLocaleDateString().slice(-4) >= "1970" &&
    new Date(startDate).toLocaleDateString().slice(-4) <= "2055" &&
    new Date(startDate) <= new Date(endDate);

  const effectiveEndDateIsValid =
    new Date(endDate).toDateString() !== "Invalid Date" &&
    endDate !== null &&
    new Date(endDate).toLocaleDateString().slice(-4) >= "1970" &&
    new Date(endDate).toLocaleDateString().slice(-4) <= "2055" &&
    new Date(startDate) <= new Date(endDate);
  /**Has Error */
  const paramNameHasError = paramNameTouched && !paramNameIsValid;
  const paramTypeHasError = paramTypeTouched && !paramTypeIsValid;
  const paramValueHasError = paramValueTouched && !paramValueIsValid;
  const effectiveStartDateHasError =
    startDateTouched && !effectiveStartDateIsValid;
  const effectiveEndDateHasError = endDateTouched && !effectiveEndDateIsValid;
  //search key
  const searchButtonRef = useRef(null);
  const viewRef = useRef(null);
  const modifyRef = useRef(null);
  const okRef = useRef(null);
  const discardOkRef = useRef(null);
  const mainDialogYesClickRef = useRef(null);
  const yesRef = useRef(null);
  const discardYesRef = useRef(null);
  const mainDialogCancelRef = useRef(null);
  const cancelRef = useRef(null);
  const discardCancelRef = useRef(null);

  const getData = async () => {
    try {
      const response = await axios.get("/parameter/getAllParameterData");
      const data = response.data.map((data) => {
        return { ...data, id: data.paramId };
      });

      const filterModule = [
        ...Array.from(new Set([...data].map((row) => row.module.trim()))).map(
          (module) => {
            return {
              label: module,
            };
          }
        ),
      ];

      setModuleArray(filterModule);

      setRows(data);
      setGlobalRows(data);
      setTotalRowsCount(data.length);
      // setParamId("");
    } catch {
      setState((pre) => {
        return { ...pre, vertical: "top", horizontal: "center" };
      });
      setAlertType("error");
      setMessage("Unable to Fetch the data");
      openAlertHandler();
    }
  };
  useEffect(() => {
    getData();
    const branchArr = GetBranchDetails();
    setBranchArray(branchArr);
    const users = store.getState().branch.userName;
    setUserName(users);
  }, [editViewMode]);
  useEffect(() => {
    window.addEventListener("keyup", onKeyPressEventHandler);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, [
    escValue,
    ParamValue,
    editViewMode,
    startDate,
    endDate,
    effectiveStartDateEnabled,
    effectiveEndDateEnabled,
  ]);

  const onKeyUnmountEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      onCancelEvent();
    } else {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "parameter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = {
      searchButtonRef: searchButtonRef,
    };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let todayDate = new Date();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      onCancelEvent();
    } else if (event.ctrlKey) {
      switch (charCode) {
        case "f":
          dispatch(
            CommonShortCutAction.getShortCutValue({
              event: event,
              refs: refList,
              screen: "parameter",
            })
          );
        case "q":
          // onCancelEvent();
          if (!showOkCancel) {
            if (discardCancelRef.current !== null) {
              discardCancelRef.current.click();
            } else if (cancelRef.current !== null) {
              cancelRef.current.click();
            } else {
              mainDialogCancelRef.current !== null &&
                mainDialogCancelRef.current.click();
            }
          }
          //  cancelRef.current !== null && cancelRef.current.click();
          break;
        case "y":
          /*  if (discardMode) {
            onOkEvent();
          } */
          if (!showOkCancel) {
            if (discardYesRef.current !== null) {
              discardYesRef.current.click();
            } else if (yesRef.current !== null) {
              yesRef.current.click();
            } else {
              mainDialogYesClickRef.current !== null &&
                mainDialogYesClickRef.current.click();
            }
          }
          // yesRef.current !== null && yesRef.current.click();
          break;
        case "k":
          /* if (showOkCancel) {
            setDialogOpen(false);
          } else if (!discardMode) {
            cancelHandleClose();
          } else if (okRef.current !== null) {
            okRef.current.click();
          } */
          if (showOkCancel) {
            okRef.current !== null && okRef.current.click();
          } else if (!discardMode) {
            discardOkRef.current !== null && discardOkRef.current.click();
          }
          break;
        case "i":
          effectiveStartDateEnabled && setstartDate(todayDate);
          effectiveEndDateEnabled && setEndDate(todayDate);
          setOkButtonHandler(false);
          break;
        case "o":
          todayDate.setDate(todayDate.getDate() + 1);
          effectiveStartDateEnabled && setstartDate(todayDate);
          effectiveEndDateEnabled && setEndDate(todayDate);
          setOkButtonHandler(false);
          break;
        case "p":
          todayDate.setDate(todayDate.getDate() - 1);
          effectiveStartDateEnabled && setstartDate(todayDate);
          effectiveEndDateEnabled && setEndDate(todayDate);
          setOkButtonHandler(false);
          break;
        default:
          break;
      }
    }
  };

  const onCancelEvent = () => {
    if (escValue) {
      if (editViewMode === "View") {
        setDialogOpen(false);
      }
      if (editViewMode === "Edit") {
        handleDialogClose();
      }
    } else {
      handleSaveDialogClose();
      cancelHandleClose();
    }
  };

  const onOkEvent = () => {
    if (escValue) {
      mainDialogYesClickRef.current.click();
    } else {
      saveDialogopen && saveDialogOkButtonClickHandler();
      cancelDialogOkButtonHandler();
    }
  };

  /**Modify Click Handler */
  const setValues = (values) => {
    setCheckObj((pre) => {
      return {
        ...pre,
        paramName: values.paramName,
        paramType: values.paramDataType,
        paramValu: values.paramValue,
        effStartDate: values.paramEffStartDate,
        effEndDate: values.paramEffEndDate,
      };
    });
  };
  const resetChecker = () => {
    setCheckObj((pre) => {
      return {
        ...pre,
        paramName: "",
        paramType: "",
        paramValu: "",
        effStartDate: dayjs(),
        effEndDate: dayjs(),
      };
    });
  };
  const viewClickHandler = (values) => {
    dispatch(ParaMeterReducerAction.updateEscapeValue(true));
    dispatch(ParaMeterReducerAction.updateEditView("View"));
    setDialogTitle("View Parameter");
    setValues(values);
    setShowOkCancel(true);
    setdisabled(true);
    handleClickDialogOpen();
    if (values.paramDataType === "Date") {
      setDateValue(true);
    } else {
      setDateValue(false);
    }
    setParamMeterName(values.paramName);
    setparamDataType(values.paramDataType);
    setstartDate(values.paramEffStartDate);
    setModules(values.module);
    setEndDate(values.paramEffEndDate);
    if (values.paramDataType === "Int") {
      setParamValue(parseInt(values.paramValue).toLocaleString("en-IN"));
    } else if (values.paramDataType === "Date") {
      setParamValue(values.paramValue);
    } else {
      setParamValue(values.paramValue);
    }
  };
  const modifyClickHandler = (values) => {
    dispatch(ParaMeterReducerAction.updateEscapeValue(true));
    dispatch(ParaMeterReducerAction.updateEditView("Edit"));
    setDialogTitle("Modify Parameter");
    setValues(values);
    setShowOkCancel(false);
    setOkButtonHandler(true);
    setdisabled(false);
    handleClickDialogOpen();
    setParamId(values.paramId);
    setParamMeterName(values.paramName);
    setparamDataType(values.paramDataType);
    setstartDate(values.paramEffStartDate);
    setEndDate(values.paramEffEndDate);
    setModules(values.module);
    if (values.paramDataType === "Int") {
      setDateValue(false);
      setParamValue(parseInt(values.paramValue).toLocaleString("en-IN"));
    } else if (values.paramDataType === "Date") {
      setDateValue(true);
      setParamValue(values.paramValue);
    } else {
      setDateValue(false);
      setParamValue(values.paramValue);
    }
  };
  //Save Dialog Click Handler
  const [saveDialogopen, setsaveDialogOpen] = React.useState(false);

  const handleSaveDialogClickOpen = () => {
    setsaveDialogOpen(true);
  };

  const handleSaveDialogClose = () => {
    setsaveDialogOpen(false);
  };
  const saveDialogOkButtonClickHandler = () => {
    SendData();
    setDialogOpen(false);
    ResetTouchHandler(false);
    resetChecker();
    setsaveDialogOpen(false);
  };
  /**Dialog Click Handler */
  const DialogOkHandler = () => {
    // setdisabled(true);
    //if save click happen
    if (
      paramNameIsValid &&
      paramTypeIsValid &&
      paramValueIsValid &&
      effectiveStartDateIsValid &&
      effectiveEndDateIsValid
    ) {
      const val =
        check.paramName === paraMeterName &&
        check.paramType === paramDataType &&
        check.effStartDate === startDate &&
        check.effEndDate === endDate &&
        (check.paramType === "Varchar" || check.paramType === "Date"
          ? check.paramValu === ParamValue
          : check.paramValu === ParamValue.replaceAll(",", ""));
      if (val) {
        setDiscardDialogTitle("Information");
        setDiscardDialog("No changes Made.");
        setDiscardMode(false);
        cancelHandleClickOpen();
        // setState((pre) => {
        //   return { ...pre, vertical: "top", horizontal: "center" };
        // });
        // setAlertType("error");
        // setMessage("No changes Made");
        // openAlertHandler();
      } else {
        dispatch(ParaMeterReducerAction.updateEscapeValue(false));
        handleSaveDialogClickOpen();
      }
    } else {
      ResetTouchHandler(true);
      return;
    }
  };
  const SendData = async () => {
    try {
      const response = await axios.post("/parameter/insertOrUpdate", {
        paramDataType: paramDataType,
        module: modules,
        branch: branchValues,
        paramEffStartDate: new Date(startDate),
        paramEffEndDate: new Date(endDate),
        paramName: paraMeterName,
        paramValue: dateValue
          ? new Date(ParamValue)
          : paramDataType === "Int"
          ? ParamValue.replaceAll(",", "")
          : ParamValue,
        paramId: paramaId,
        createdBy: userName,
        lastModifiedBy: userName,
      });

      getData();
      setParamId("");
      if (paramaId === "") {
        setState((pre) => {
          return { ...pre, vertical: "bottom", horizontal: "left" };
        });
        setAlertType("success");
        setMessage("Record added Successfully");
        openAlertHandler();
        setModules("");
      } else {
        setDiscardDialogTitle("Information");
        setDiscardDialog("Parameter Maintenance Value Updated Successfully.");
        setDiscardMode(false);
        cancelHandleClickOpen();
        // setState((pre) => {
        //   return { ...pre, vertical: "bottom", horizontal: "left" };
        // });
        // setAlertType("success");
        // setMessage("Record Updated Successfully");
        // openAlertHandler();
      }

      Reset();
    } catch {
      setState((pre) => {
        return { ...pre, vertical: "top", horizontal: "center" };
      });
      setAlertType("error");
      if (paramaId === "") {
        setMessage("Unable to Perform add operation");
        openAlertHandler();
      } else {
        setMessage("Unable to Perform Update operation");
        openAlertHandler();
      }
    }
  };
  /** Show Dialog Handlers */
  const [Dialogopen, setDialogOpen] = React.useState(false);
  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    if (
      !effectiveStartDateIsValid ||
      !effectiveEndDateIsValid ||
      !paramValueIsValid
    ) {
      dispatch(ParaMeterReducerAction.updateEscapeValue(false));
      cancelHandleClickOpen();
      setDiscardDialogTitle("Confirmation");
      setDiscardDialog("Are you sure want to discard the changes ?");
      setDiscardMode(true);
    } else {
      if (
        check.paramName === paraMeterName &&
        check.paramType === paramDataType &&
        new Date(check.effStartDate).toISOString().slice(0, 10) ===
          new Date(startDate).toISOString().slice(0, 10) &&
        new Date(check.effEndDate).toISOString().slice(0, 10) ===
          new Date(endDate).toISOString().slice(0, 10) &&
        (check.paramType === "Varchar"
          ? check.paramValu === ParamValue
          : check.paramType === "Date"
          ? check.paramValu === ParamValue
          : check.paramValu === ParamValue.replaceAll(",", ""))
      ) {
        setdisabled(true);
        setDialogOpen(false);
        Reset();
        ResetTouchHandler(false);
        resetChecker();
      } else {
        dispatch(ParaMeterReducerAction.updateEscapeValue(false));
        cancelHandleClickOpen();
        setDiscardDialogTitle("Confirmation");
        setDiscardDialog("Are you sure want to discard the changes ?");
        setDiscardMode(true);
      }
    }
  };
  const addBtnHandler = () => {
    setDialogTitle("Create Parameter");
    setDateValue(false);
    setMode(0);
    setOkButtonHandler(false);
    Reset();
    setdisabled(false);
    setDialogOpen(true);
    setShowOkCancel(false);
  };
  const goBtnHandler = () => {
    const filteredData =
      pModule === ""
        ? globalRows
        : globalRows.filter((rows) => rows.module.trim() === pModule.trim());
    setRows(filteredData);
  };
  /**Reset All values */
  const Reset = () => {
    setParamId("");
    setParamMeterName("");
    setparamDataType("");
    setstartDate(dayjs());
    setEndDate(dayjs());
    setParamValue("");
  };
  /**Validation Handlers */

  const ResetTouchHandler = (value) => {
    setParamNameTouched(value);
    setParamTypeTouched(value);
    setStartDateTouched(value);
    setEndDateTouched(value);
    setParamValueTouched(value);
  };

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [state, setState] = React.useState({
    open: false,
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal, open } = state;
  const [alert, setAlert] = useState(false);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  /**Checking value Changes */
  const [check, setCheckObj] = useState({
    paramName: "",
    paramType: "",
    paramValu: "",
    effStartDate: dayjs(),
    effEndDate: dayjs(),
  });

  const cancelHandleClickOpen = () => {
    cancelSetOpen(true);
  };

  const cancelHandleClose = () => {
    cancelSetOpen(false);
    dispatch(ParaMeterReducerAction.updateEscapeValue(true));
  };
  const cancelDialogOkButtonHandler = () => {
    resetChecker();
    cancelSetOpen(false);
    setdisabled(true);
    setDialogOpen(false);
    Reset();
    ResetTouchHandler(false);
  };
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer title="Parameter Maintenance" initialOpen={true}>
          <Box
            sx={{
              marginTop: "5px",
              marginBottom: "5px",
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "30px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <InputLabel sx={{ color: "#004A92", fontWeight: 400 }}>
                Branch
              </InputLabel>
              <FormControl>
                <Autocomplete
                  sx={{ width: "250px" }}
                  variant="standard"
                  type="text"
                  placeholder="Select Module"
                  options={branchArray}
                  disabled={true}
                  value={branchDetails.branchName}
                  // onChange={(e, value) => {
                  //   setBranchValues(value == null ? "" : value.label);
                  //   if (value !== null) {
                  //     dispatch(BranchAction.updateInitialLoad(false));
                  //     dispatch(
                  //       BranchAction.updateHeaderBranchDetails(value.label)
                  //     );
                  //   }
                  // }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" autoFocus />
                  )}
                />
              </FormControl>
            </Box>
            {/* Module search */}

            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <InputLabel sx={{ color: "#004A92", fontWeight: 400 }}>
                Module
              </InputLabel>
              <FormControl>
                <Autocomplete
                  sx={{ width: "250px" }}
                  variant="standard"
                  type="text"
                  placeholder="Select Module"
                  options={moduleArray}
                  value={pModule}
                  onChange={(e, value) => {
                    setModule(value == null ? "" : value.label);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" autoFocus />
                  )}
                />
              </FormControl>
            </Box>

            <Box>
              <Tooltip title="Ctrl+F" placement="top">
                <Button
                  sx={{ fontWeight: "bold" }}
                  variant="contained"
                  onClick={goBtnHandler}
                  ref={searchButtonRef}
                >
                  Go
                </Button>
              </Tooltip>
            </Box>
            {/* <Button
            sx={{ fontWeight: "bold", marginLeft: "100px" }}
            variant="contained"
            onClick={addBtnHandler}
          >
            Add
          </Button> */}
          </Box>
          {useMediaQuery("(min-width:1200px)") && (
            <Box>
              <CustomDataGrid
                noDataMessage="No Data."
                noDataOnFilterMessage="No Data on Applied Filter."
                rows={rows}
                rowHeight={40}
                columns={columnsData}
                pageSize={10}
                pageSizeOptions={[10]}
                gridLazyLoad={() => {}}
                onSortModelChange={() => {}}
              />
            </Box>
          )}
          {useMediaQuery("(max-width:1200px)") && (
            <>
              <Box
                display="flex"
                alignItems="flex-end"
                justifyContent="flex-end"
                sx={{ bgcolor: "white" }}
              >
                {totalRowsCount > 10 && (
                  <Typography sx={{ mr: 2, color: "#004A92", fontWeight: 700 }}>
                    {"Page Max Records : " + rowsPerPage}
                  </Typography>
                )}
                <Typography
                  padding="1px"
                  sx={{
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Total Records : " + totalRowsCount}
                </Typography>
              </Box>
              <Box
                sx={{
                  overflow: "auto",
                  flex: "1 auto",
                }}
              >
                <Grid container>
                  {rows.map((row, index) => {
                    return (
                      <Grid item xs={12} md={6}>
                        <Card>
                          <CardHeader
                            action={
                              <React.Fragment>
                                {
                                  <MoreAction
                                    params={row}
                                    viewClickHandler={viewClickHandler}
                                    modifyClickHandler={modifyClickHandler}
                                    viewRef={viewRef}
                                    modifyRef={modifyRef}
                                  />
                                }
                              </React.Fragment>
                            }
                            subheader={"Parameter Name : " + row.paramName}
                            subheaderTypographyProps={{
                              color: "#004A92",
                              fontWeight: "700",
                            }}
                            sx={{
                              textAlign: "left",
                              padding: "16px 16px 0px 16px !important",
                            }}
                          />

                          <CardContent>
                            <Grid container>
                              <Grid item xs={7} md={5}>
                                Paramete Data Type
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {`: ${row.paramDataType}`}
                              </Grid>

                              <Grid item xs={7} md={5}>
                                Effective Start Date
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {`: ${dayjs(row.paramEffStartDate).format(
                                  "DD/MM/YYYY"
                                )}`}
                              </Grid>

                              <Grid item xs={7} md={5}>
                                Effective End Date
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {`: ${dayjs(row.paramEffEndDate).format(
                                  "DD/MM/YYYY"
                                )}`}
                              </Grid>

                              <Grid item xs={7} md={5}>
                                Parameter Value
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {`: ${
                                  row.paramDataType === "Int"
                                    ? parseInt(row.paramValue).toLocaleString(
                                        "en-IN"
                                      )
                                    : row.paramDataType === "Date"
                                    ? dayjs(row.paramValue).format("DD/MM/YYYY")
                                    : row.paramValue
                                }`}
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                  {rows.length === 0 && (
                    <NoDataFound
                      message={"No Data."}
                      imageStyle={{
                        marginTop:
                          // accordianOpen && window.innerHeight < 1000
                          //   ? "20px"
                          // :
                          "20%",
                      }}
                    />
                  )}
                </Grid>
              </Box>
            </>
          )}

          <Dialog open={Dialogopen}>
            <DialogTitle>
              <h4>{dialogTitle}</h4>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    label="Parameter Name"
                    variant="standard"
                    value={paraMeterName}
                    error={paramNameHasError}
                    disabled={true}
                    onChange={(e) => {
                      setOkButtonHandler(false);
                      setParamMeterName(e.target.value);
                    }}
                    onBlur={(e) => {
                      setParamNameTouched(true);
                    }}
                  />
                  {paramNameHasError && (
                    <p className="error">Please Enter Valid Parameter Name </p>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomDropDown
                    label="Parameter Data Type"
                    variant="standard"
                    disabled={true}
                    value={paramDataType}
                    error={paramTypeHasError}
                    dropDownValue={[
                      { key: 0, value: "Varchar", text: "Varchar" },
                      { key: 1, value: "Int", text: "Int" },
                      { key: 2, value: "Date", text: "Date" },
                      { key: 3, value: "Float", text: "Float" },
                    ]}
                    onChange={(e) => {
                      if (e.target.value === "Date") {
                        setDateValue(true);
                      } else {
                        setDateValue(false);
                      }
                      setOkButtonHandler(false);
                      setparamDataType(e.target.value);
                      setParamValue("");
                    }}
                    onBlur={(e) => {
                      setParamTypeTouched(true);
                    }}
                  />
                  {paramTypeHasError && (
                    <p className="error">Please Enter valid Parameter Type </p>
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <CustomDateField
                    id="start-date"
                    PopperProps={{
                      placement: "auto",
                    }}
                    required={true}
                    value={startDate}
                    label="Effective Start Date"
                    variant="standard"
                    minDate={"1970/01/01"}
                    maxDate={"2055/12/31"}
                    disabled={disabled}
                    onChange={(newValue) => {
                      setDiscardMode(true);
                      setOkButtonHandler(false);
                      setstartDate(newValue);
                      setStartDateTouched(true);
                    }}
                    onBlur={(e) => {
                      setStartDateTouched(true);
                    }}
                    onOpen={(event) => {
                      setEffectiveStartDateEnabled(true);
                      setEffectiveEndDateEnabled(false);
                    }}
                    onSelect={(event) => {
                      console.log(23);
                    }}
                  />
                  {effectiveStartDateHasError && (
                    <p className="error">
                      Please Enter Valid Effective Start Date
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomDateField
                    id="end-date"
                    PopperProps={{
                      placement: "auto",
                    }}
                    required={true}
                    value={endDate}
                    minDate={"1970/01/01"}
                    maxDate={"2055/12/31"}
                    label="Effective End Date"
                    variant="standard"
                    disabled={disabled}
                    onChange={(newValue) => {
                      setDiscardMode(true);
                      setOkButtonHandler(false);
                      setEndDate(newValue);
                      setEndDateTouched(true);
                    }}
                    onBlur={(e) => {
                      setEndDateTouched(true);
                    }}
                    onOpen={(event) => {
                      setEffectiveEndDateEnabled(true);
                      setEffectiveStartDateEnabled(false);
                    }}
                  />
                  {effectiveEndDateHasError && (
                    <p className="error">
                      Please Enter Valid Effective End Date
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  {dateValue && (
                    <CustomDateField
                      required={true}
                      value={ParamValue}
                      disableFuture={false}
                      disablePast={true}
                      label="Date"
                      variant="standard"
                      disabled={disabled}
                      onChange={(value) => {
                        setParamValue(value);
                        setOkButtonHandler(false);
                      }}
                    />
                  )}
                  {!dateValue && (
                    <CustomTextField
                      required={true}
                      value={ParamValue}
                      label="Parameter Value"
                      variant="standard"
                      disabled={disabled}
                      error={paramValueHasError}
                      onBlur={(e) => {
                        if (paramDataType === "Float") {
                          setParamValueTouched(true);
                          var new_value = Number(ParamValue) * 1; //removes trailing zeros
                          new_value = new_value + ""; //casts it to string

                          let pos = new_value.indexOf(".");
                          if (pos == -1) new_value = new_value + ".00";
                          else {
                            var integer = new_value.substring(0, pos);
                            var decimals = new_value.substring(pos + 1);
                            while (decimals.length < 2)
                              decimals = decimals + "0";
                            new_value = integer + "." + decimals;
                          }
                          setParamValue(new_value);
                        } else {
                          setParamValueTouched(true);
                        }
                      }}
                      onChange={(e) => {
                        setDiscardMode(true);
                        setOkButtonHandler(false);
                        if (paramDataType === "Varchar") {
                          let val = e.target.value.replace(/[0-9]/g, "");
                          setParamValue(val);
                        } else if (paramDataType === "Float") {
                          setParamValue(e.target.value);
                        } else {
                          let Value = e.target.value.replace(/\D/g, "");
                          if (Value === "") {
                            setParamValue(Value);
                            setParamErrorMessage(
                              "Please Enter Valid Parameter Value"
                            );
                          } else {
                            let val = parseInt(
                              Value.replaceAll(",", "")
                            ).toLocaleString("en-IN");
                            if (val == 0) {
                              setParamErrorMessage(
                                "Please Enter Minimum Parameter Value"
                              );
                            } else {
                              setParamErrorMessage(
                                "Please Enter Valid Parameter Value"
                              );
                            }
                            setParamValue(
                              parseInt(
                                Value.replaceAll(",", "")
                              ).toLocaleString("en-IN")
                            );
                          }
                        }
                      }}
                    />
                  )}

                  {paramValueHasError && (
                    <p className="error">{paramErrorMessage} </p>
                  )}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              {showOkCancel ? (
                <Tooltip title="Ctrl+K" placement="left">
                  <Button
                    onClick={() => {
                      setDialogOpen(false);
                    }}
                    ref={okRef}
                  >
                    OK
                  </Button>
                </Tooltip>
              ) : (
                <>
                  <Tooltip title="Ctrl+Q" placement="left">
                    <Button
                      onClick={handleDialogClose}
                      ref={mainDialogCancelRef}
                    >
                      Cancel
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ctrl+Y" placement="right">
                    <Button
                      onClick={DialogOkHandler}
                      disabled={OkButtonHandler}
                      ref={mainDialogYesClickRef}
                    >
                      Yes
                    </Button>
                  </Tooltip>
                </>
              )}
            </DialogActions>
          </Dialog>
          <div>
            <Dialog
              open={saveDialogopen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  Update Value of Parameter Maintenance ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Tooltip title="Ctrl+Q" placement="left">
                  <Button onClick={handleSaveDialogClose} ref={cancelRef}>
                    Cancel
                  </Button>
                </Tooltip>
                <Tooltip title="Ctrl+Y" placement="right">
                  <Button onClick={saveDialogOkButtonClickHandler} ref={yesRef}>
                    Yes
                  </Button>
                </Tooltip>
              </DialogActions>
            </Dialog>
          </div>
        </AccordianContainer>
      </Box>

      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Dialog
        open={cancelOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{discardDialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {discardDialog}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          {discardMode && (
            <>
              <Tooltip title="Ctrl+Q" placement="left">
                <Button onClick={cancelHandleClose} ref={discardCancelRef}>
                  Cancel
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+Y" placement="right">
                <Button
                  onClick={cancelDialogOkButtonHandler}
                  ref={discardYesRef}
                >
                  Yes
                </Button>
              </Tooltip>
            </>
          )}
          {!discardMode && (
            <Tooltip title="Ctrl+K" placement="left">
              <Button onClick={cancelHandleClose} ref={discardOkRef}>
                Ok
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>

      <StlapFooter />
    </>
  );
};

export default ParameterMaintenance;
